<template>
  <div class="prog-wrapper">

    <!-- Page Header -->
    <div class="page-header">
      <h1 class="page-header-title"><i class="bi bi-file-earmark-text me-2"></i>Programación de Documentos</h1>
      <div class="prog-header-actions">
        <!-- La fecha manda en todo: agendas abiertas, Vista del día, Ruta Final y Reporte por vehículo -->
        <input type="date" class="prog-date-input" aria-label="Fecha de programación" title="Fecha de programación"
          @change="actualizarInformacionDia()" v-model="fechaDelDia" />
        <button class="prog-btn prog-btn-secondary" @click="abrirVistaDia()">
          <i class="bi bi-grid-3x3-gap me-1"></i> Vista del día
        </button>
        <button class="prog-btn prog-btn-primary" @click="reporteDia()" :disabled="descargando">
          <i class="bi bi-file-earmark-pdf me-1"></i> Ruta Final
        </button>
      </div>
    </div>

    <!-- Leyenda -->
    <div class="prog-leyenda">
      <span class="leyenda-label">Estado:</span>
      <span class="leyenda-chip" style="background:#d4edda; border-color:#b1dfbb;">
        <span class="leyenda-dot" style="background:#28a745;"></span> Disponible
      </span>
      <span class="leyenda-chip" style="background:#fff3cd; border-color:#ffeeba;">
        <span class="leyenda-dot" style="background:#ffc107;"></span> No Disponible
      </span>
      <span class="leyenda-chip" style="background:#f8d7da; border-color:#f5c6cb;">
        <span class="leyenda-dot" style="background:#dc3545;"></span> Ocupado
      </span>
    </div>

    <!-- Modal Vista del Día (iframe) -->
    <div v-if="showModalProgramacion" class="modal fade show d-block" id="iframeModal" tabindex="-1"
      @keydown.esc="closeModalProgramacion" style="background: rgba(0,0,0,0.5);">
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title"><i class="bi bi-grid-3x3-gap me-2"></i>Programación del día</h5>
            <button type="button" class="btn-close" @click="closeModalProgramacion()"></button>
          </div>
          <div class="modal-body p-0 prog-iframe-body">
            <div v-if="cargandoVistaDia" class="prog-iframe-cargando">
              <span class="spinner-border spinner-border-sm me-2"></span>Cargando programación…
            </div>
            <iframe v-else :srcdoc="reporteDiaHtml" title="Programación del día" class="prog-iframe"></iframe>
          </div>
        </div>
      </div>
    </div>

    <!-- Tarjetas de Vehículos -->
    <div class="prog-vehicles">
      <div class="prog-vehicle-card" v-for="(vehiculo, index) in vehiculos" :key="vehiculo.id_vehiculo"
        :style="{ borderLeftColor: getBorderColor(vehiculo.color_estado) }">

        <!-- Card header -->
        <div class="prog-vehicle-header" :style="{ background: vehiculo.color_estado || '#f8f9fa' }">
          <div class="prog-vehicle-info">
            <div class="prog-vehicle-name">
              <i class="bi bi-truck me-2" style="color:#3f51b5;"></i>
              <span>{{ vehiculo.nombre_vehiculo || 'Sin nombre' }}</span>
            </div>
            <div class="prog-vehicle-detail">{{ detalleVehiculo(vehiculo) }}</div>
          </div>
          <div class="prog-vehicle-actions">
            <button v-if="vehiculo.id_asignacion" class="prog-vbtn" @click="toggleCalendario(index)"
              :title="vehiculo.mostrarCalendario ? 'Ocultar agenda' : 'Ver agenda'">
              <i :class="vehiculo.mostrarCalendario ? 'bi bi-calendar-x' : 'bi bi-calendar3'"></i>
              <span class="d-none d-md-inline ms-1">{{ vehiculo.mostrarCalendario ? 'Ocultar' : 'Agenda' }}</span>
            </button>
            <button v-if="vehiculo.id_asignacion" class="prog-vbtn" @click="viewDetails(vehiculo)" title="Ver detalle">
              <i class="bi bi-info-circle"></i>
              <span class="d-none d-md-inline ms-1">Detalle</span>
            </button>
            <button v-if="vehiculo.id_asignacion" class="prog-vbtn prog-vbtn-pdf" @click="generarPdf(vehiculo)"
              :disabled="descargando" title="Descargar la ruta del vehículo (fecha de su agenda)">
              <i class="bi bi-file-earmark-pdf"></i>
              <span class="d-none d-md-inline ms-1">Reporte</span>
            </button>
            <button v-if="!vehiculo.id_asignacion" class="prog-vbtn prog-vbtn-warn" @click="pedirInformacion()" title="Pedir información">
              <i class="bi bi-question-circle"></i>
              <span class="d-none d-md-inline ms-1">Pedir info</span>
            </button>
          </div>
        </div>

        <!-- Calendario colapsable: se crea solo al abrirlo (antes cada vehículo pedía sus eventos al cargar la página) -->
        <transition name="fade">
          <div v-if="vehiculo.mostrarCalendario" class="prog-calendar-body">
            <FullCalendar :options="opcionesCalendario(vehiculo)" :ref="'calendar' + vehiculo.id_vehiculo" />
          </div>
        </transition>
      </div>
    </div>

    <!-- Modal Registro de Envío -->
    <div v-if="showModal" class="modal fade show d-block" tabindex="-1" style="background: rgba(0,0,0,0.5);"
      @keydown.esc="closeModal">
      <div class="modal-dialog modal-xxl">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title"><i class="bi bi-pencil-square me-2"></i>Registro de Envío</h5>
            <button type="button" class="btn-close" @click="closeModal"></button>
          </div>
          <div class="modal-body">
            <ShippingLocalDocument ref="shippingLocalRef" :idVehiculo="datos.id_vehiculo"
              :personalChofer="datos.personal_chofer" :fecha-salida="datos.fecha_salida"
              :horario-salida="datos.horario_salida" :fecha-entrada="datos.fecha_entrada"
              :idEnvioLocal="datos.id_envio_local" />
          </div>
          <!-- Pie fijo: Guardar siempre visible aunque el formulario sea largo; Eliminar separado a la izquierda -->
          <div class="modal-footer">
            <button v-if="datos.id_envio_local" @click.prevent="eliminarEnvio()" class="btn btn-outline-danger me-auto">
              <i class="bi bi-trash me-1"></i> Eliminar
            </button>
            <button class="btn btn-secondary" @click="closeModal">Cancelar</button>
            <button @click="guardarShipping" class="btn btn-primary">
              <i class="bi bi-floppy me-1"></i> Guardar
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Detalle Vehículo -->
    <div v-if="showDetailModal" class="modal fade show d-block" tabindex="-1" style="background: rgba(0,0,0,0.5);">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title"><i class="bi bi-truck me-2"></i>{{ vehiculo.nombre_vehiculo }}</h5>
            <button type="button" class="btn-close" @click="closeDetailModal"></button>
          </div>
          <div class="modal-body p-0">
            <table class="prog-detail-table">
              <colgroup><col style="width:42%;"><col style="width:58%;"></colgroup>
              <tbody>
                <tr><td class="det-label">MARCA</td><td>{{ vehiculo.marca_vehiculo }}</td></tr>
                <tr><td class="det-label">MODELO</td><td>{{ vehiculo.modelo_vehiculo }}</td></tr>
                <tr><td class="det-label">PLACA</td><td>{{ vehiculo.placa_vehiculo }}</td></tr>
                <tr><td class="det-label">PESO DE CARGA</td><td>{{ vehiculo.peso_vehiculo }}</td></tr>
                <tr><td class="det-label">DIMENSIÓN</td><td>{{ vehiculo.medidas_vehiculo }}</td></tr>
                <tr v-if="vehiculo.tipo_vehiculo !== 'MOTORIZADO'">
                  <td class="det-label">PALLETS</td><td>{{ vehiculo.pallets_vehiculo }}</td>
                </tr>
                <tr><td class="det-label">TELÉFONO</td><td>{{ vehiculo.telefono }}</td></tr>
                <tr><td colspan="2" class="det-section-header">CHOFER</td></tr>
                <tr><td class="det-label">NOMBRE</td><td>{{ vehiculo.nombre_chofer }}</td></tr>
                <tr><td class="det-label">DNI / CE</td><td>{{ vehiculo.nro_doc_chofer }}</td></tr>
                <tr><td class="det-label">LICENCIA</td><td>{{ vehiculo.licencia_chofer }}</td></tr>
                <tr>
                  <td class="det-label">CORREO</td>
                  <td><a :href="'mailto:' + vehiculo.correo_chofer">{{ vehiculo.correo_chofer }}</a></td>
                </tr>
                <template v-if="vehiculo.tipo_vehiculo !== 'MOTORIZADO'">
                  <tr><td colspan="2" class="det-section-header">AUXILIAR</td></tr>
                  <tr><td class="det-label">NOMBRE</td><td>{{ vehiculo.nombre_auxiliar }}</td></tr>
                  <tr><td class="det-label">DNI / CE</td><td>{{ vehiculo.nro_doc_auxiliar }}</td></tr>
                  <tr>
                    <td class="det-label">CORREO</td>
                    <td><a :href="'mailto:' + vehiculo.correo_auxiliar">{{ vehiculo.correo_auxiliar }}</a></td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
          <div class="modal-footer">
            <button class="btn btn-secondary" @click="closeDetailModal">Cerrar</button>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import FullCalendar from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction'
import esLocale from '@fullcalendar/core/locales/es'
import ShippingLocalDocument from '../components/ShippingLocalDocument.vue'
import axios from 'axios'
import Swal from 'sweetalert2'
import { fechaLocal, escaparHtml } from '@/utils/programacion'
import { mensajeErrorDescarga } from '@/utils/rangoFechas'
export default {
  name: 'ProgramacionPage',

  components: { FullCalendar, ShippingLocalDocument },


  data() {
    return {
      showModal: false,
      showModalProgramacion: false,
      vehiculo: {},
      showDetailModal: false,
      event: { title: '', time: '', id: null },
      vehiculos: [],
      fechaDelDia: "",
      reporteDiaHtml: "",
      cargandoVistaDia: false,
      descargando: false,
      datos: {
        fecha_salida: '',
        horario_salida: '',
        fecha_entrada: '',
        id_vehiculo: '',
        personal_chofer: '',
        id_envio_local: null
      }
    }
  },
  created() {
    this.fechaDelDia = fechaLocal(new Date())
    // Opciones de FullCalendar por vehículo: se crean una vez por apertura de la agenda
    // (crearlas en cada render hacía que el calendario se reconfigurara a cada cambio de la página)
    this.opcionesPorVehiculo = {}
  },

  methods: {
    pedirInformacion() {
      Swal.fire({
        title: '¡Información recibida!',
        text: 'Se notificará a los encargados para solicitar los datos del vehículo y se contactará a la persona correspondiente. ¡Gracias!',
        icon: 'info',
        confirmButtonText: 'Aceptar'
      });
    },
    // Cambio de fecha en la cabecera: las agendas abiertas y la Vista del día pasan a esa fecha
    actualizarInformacionDia() {
      if (!this.fechaDelDia) return
      this.vehiculos.forEach(v => {
        const calendario = this.$refs[`calendar${v.id_vehiculo}`]?.[0]
        if (calendario) calendario.getApi().gotoDate(this.fechaDelDia)
      })
      if (this.showModalProgramacion) this.cargarReporteDia()
    },
    abrirVistaDia() {
      this.showModalProgramacion = true
      this.cargarReporteDia()
    },
    // El reporte se pide con el token (axios) y se muestra en el iframe con srcdoc:
    // un iframe con src directo no puede enviar el token. Se pide solo al abrir la Vista del día.
    async cargarReporteDia() {
      this.cargandoVistaDia = true
      try {
        const { data } = await axios.get(`rutaDiaDocumentos/${this.fechaDelDia}`, { responseType: "text" });
        this.reporteDiaHtml = data;
      } catch (error) {
        this.reporteDiaHtml = "<p style=\"font-family:sans-serif;padding:24px;color:#6b7085\">No se pudo cargar la programación del día.</p>";
        console.error("Error al cargar el reporte del día", error);
      } finally {
        this.cargandoVistaDia = false
      }
    },
    detalleVehiculo(vehiculo) {
      const partes = []
      if (vehiculo.tipo_vehiculo === 'CAMION') partes.push(`Máx. ${vehiculo.pallets_vehiculo || 0} pallet`)
      else if (vehiculo.tipo_vehiculo === 'MOTORIZADO') partes.push(`Medidas máx. ${vehiculo.medidas_vehiculo || 'N/A'}`)
      partes.push(`Placa: ${vehiculo.placa_vehiculo || 'N/A'}`)
      const chofer = vehiculo.nombre_chofer ? vehiculo.nombre_chofer.split(' ')[0] : 'Sin chofer'
      const auxiliar = vehiculo.nombre_auxiliar ? vehiculo.nombre_auxiliar.split(' ')[0] : 'Sin auxiliar'
      partes.push(`Personal: ${vehiculo.tipo_vehiculo === 'MOTORIZADO' ? chofer : `${chofer} + ${auxiliar}`}`)
      return partes.join(' · ')
    },

    async getVehiculos() {
      const response = await axios.get('/vehiculos-local-documentos')
      this.vehiculos = response.data.map(v => ({
        ...v,
        mostrarCalendario: false,
        fechaAgenda: null // fecha que muestra su agenda (para el Reporte del vehículo)
      }));
    },

    async guardarShipping() {
      try {
        const resultado = await this.$refs.shippingLocalRef.submitDesdePadre();
        if (resultado && resultado.envio) {
          this.refrescarAgenda(resultado.envio.id_vehiculo, resultado.envio.fecha_salida)
          this.showModal = false;
        }
      } catch (error) {
        console.error('Error al guardar desde el hijo:', error);
      }
    },
    async eliminarEnvio() {
      try {
        const resultado = await this.$refs.shippingLocalRef.eliminarDesdePadre();
        if (resultado) {
          this.refrescarAgenda(this.vehiculo.id_vehiculo, resultado.fecha_salida);
          this.closeModal();
        }
      } catch (error) {
        console.error('Error al eliminar desde el hijo:', error);
      }
    },
    // Tras guardar o eliminar: la agenda del vehículo (si está abierta) muestra la fecha del envío actualizada
    refrescarAgenda(idVehiculo, fecha) {
      const calendario = this.$refs[`calendar${idVehiculo}`]?.[0]
      if (!calendario || !fecha) return
      const api = calendario.getApi()
      if (fechaLocal(api.getDate()) === fecha) this.loadEvents(fecha, idVehiculo)
      else api.gotoDate(fecha) // datesSet vuelve a cargar los eventos
    },
    async loadEvents(fecha, idVehiculo) {
      try {
        const response = await axios.get(`/getEventos/${fecha}/${idVehiculo}`);
        const eventos = response.data;
        // Llenamos el calendario con los eventos obtenidos (si la agenda se cerró mientras tanto, no hay nada que pintar)
        const calendarRef = this.$refs[`calendar${idVehiculo}`]?.[0];
        if (!calendarRef) return;
        const calendarApi = calendarRef.getApi();
        calendarApi.removeAllEvents();

        // Luego agregamos los eventos nuevos
        eventos.forEach(event => {
          let startTime = `${event.fecha}T${event.hora}`;
          let background = "";
          let textoConcatenado = `Rastreo: ${event.rastreo} \n`;

          if (event.programacion === "cita") {
            textoConcatenado += "CITA ";
          }

          if (event.tipo_evento == "parada") {
            textoConcatenado += `PARADA\n nombre: ${event.parada_nombre} \n dirección: ${event.parada_direccion}\n`;
          }

          if (event.tipo_evento != "recojo_cita" && event.tipo_evento != "entrega_cita") {
            textoConcatenado += `Código: ${event.codigo}\n Detalle: ${event.tipo_detalle}\n `;
          }



          // Diccionario para mensajes por tipo_evento
          const mensajes = {
            recojo: `Recojo de: ${event.sucursal_origen}, Contacto: ${event.contacto_origen}, Teléfono: ${event.telefono_origen}`,
            entrega: `Entrega en: ${event.sucursal_destino}, Contacto: ${event.contacto_destino}, Teléfono: ${event.telefono_destino}`,
            fuera_corte: `Entrega en: ${event.sucursal_destino}, Contacto: ${event.contacto_destino}, Teléfono: ${event.telefono_destino}`,
            recojo_cita: `Tiempo reservado para una cita`,
            entrega_cita: `Tiempo reservado para una cita`,
          };

          if (mensajes[event.tipo_evento]) {
            textoConcatenado += mensajes[event.tipo_evento];
          }

          // Colores de fondo por tipo_evento
          const colores = {
            recojo: "#E2EFDA",
            entrega: "#FFF2CC",
            recojo_cita: "#A9D18E",
            entrega_cita: "#FFD966",
            fuera_corte: "#FBDDD9",
            parada: "#A7DBFA"
          };

          background = colores[event.tipo_evento] || "";



          calendarApi.addEvent({
            id: event.id_envio_local, // Suponiendo que el backend devuelve un campo 'id'
            title: textoConcatenado, // Suponiendo que el evento tiene un campo 'observaciones'
            start: startTime, // Suponiendo que el evento tiene una fecha de salida
            backgroundColor: background, // Color de fondo (puedes usar un color hexadecimal o un nombre de color)
            textColor: "#000000"
          });
        });
      } catch (error) {
        console.error('Error al cargar los eventos:', error);
      }
    },
    closeModalProgramacion() {
      this.showModalProgramacion = false
    },

    opcionesCalendario(vehiculo) {
      if (!this.opcionesPorVehiculo[vehiculo.id_vehiculo]) {
        this.opcionesPorVehiculo[vehiculo.id_vehiculo] = this.getCalendarOptions(vehiculo)
      }
      return this.opcionesPorVehiculo[vehiculo.id_vehiculo]
    },
    getCalendarOptions(vehiculo) {

      return {
        dateClick: (info) => {
          this.vehiculo = vehiculo
          this.handleDateClick(info);

        },
        // El vehículo es el de esta agenda (antes se usaba el último vehículo tocado en otra tarjeta)
        eventClick: (info) => {
          this.vehiculo = vehiculo;
          this.handleEventClick(info);
        },
        plugins: [dayGridPlugin, timeGridPlugin, interactionPlugin],
        initialView: 'timeGridDay',
        initialDate: vehiculo.fechaAgenda || this.fechaDelDia,
        // Flechas como texto: los íconos de FullCalendar salían como cuadros vacíos
        buttonIcons: false,
        buttonText: { today: 'Hoy', prev: '‹', next: '›' },
        buttonHints: { prev: 'Día anterior', next: 'Día siguiente', today: 'Ir a hoy' },
        slotMinTime: '06:00:00',
        slotMaxTime: '19:00:00',
        slotDuration: '01:00:00',
        slotLabelInterval: '01:00:00',
        allDaySlot: false,
        // Mover un evento arrastrándolo no se guardaba (no hay eventDrop): se edita abriéndolo
        editable: false,
        eventOverlap: false,
        eventOrderStrict: true,
        dayMaxEventRows: true,
        height: 'auto',
        locale: esLocale,
        eventContent: function (arg) {
          // Divide el título por salto de línea y crea un div con <br>
          // Los textos vienen de lo que registran los clientes (contactos, observaciones): se escapan
          const lines = arg.event.title.split('\n');
          return {
            html: lines.map(line => `<div>${escaparHtml(line)}</div>`).join('')
          };
        },

        datesSet: (info) => {
          const fecha = fechaLocal(info.view.currentStart);
          vehiculo.fechaAgenda = fecha;
          this.loadEvents(fecha, vehiculo.id_vehiculo);
        },

      };
    },
    // Descarga un PDF del API (con token) y avisa si falla en vez de no hacer nada
    async descargarPdf(url, nombre) {
      this.descargando = true
      try {
        const response = await axios.get(url, { responseType: 'blob' });
        const enlace = document.createElement('a');
        enlace.href = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
        const ahora = new Date();
        enlace.download = `${nombre}_${fechaLocal(ahora).replace(/-/g, '')}_${ahora.toTimeString().slice(0, 8).replace(/:/g, '')}.pdf`;
        document.body.appendChild(enlace);
        enlace.click();
        document.body.removeChild(enlace);
        window.URL.revokeObjectURL(enlace.href);
      } catch (error) {
        console.error('Error al generar el PDF:', error);
        Swal.fire({ icon: 'error', title: 'Error', text: await mensajeErrorDescarga(error, 'No se pudo generar el PDF. Intenta nuevamente.') });
      } finally {
        this.descargando = false
      }
    },
    reporteDia() {
      return this.descargarPdf(`/exportarRutaDiaDocumentos/${this.fechaDelDia}`, 'reporte_general_dia')
    },
    // Ruta del vehículo para la fecha que muestra su agenda (o la fecha de la cabecera si está cerrada)
    generarPdf(vehiculo) {
      const fecha = vehiculo.fechaAgenda || this.fechaDelDia
      return this.descargarPdf(`/ruta-documentos/${vehiculo.id_vehiculo}/${fecha}`, `reporte_ruta_${vehiculo.id_vehiculo}`)
    },
    async handleDateClick(info) {
      this.event.time = info.dateStr.substring(11, 16)
      this.event.id = null

      const dateStr = info.dateStr;
      const date = new Date(dateStr);
      let hora = date.toTimeString().split(':').slice(0, 2).join(':');
      // Fecha local del casillero (toISOString daba la fecha en UTC)
      const fecha = fechaLocal(date);

      // VALIDACIÓN: Fecha es hoy y hora >= 04:01
      const ahora = new Date();
      const esHoy =
        date.getFullYear() === ahora.getFullYear() &&
        date.getMonth() === ahora.getMonth() &&
        date.getDate() === ahora.getDate();

      // Hoy no se registran envíos desde las 4:00 p.m. (hora actual, no la del casillero)
      if (esHoy && ahora.getHours() >= 16) {
        await Swal.fire({
          icon: 'warning',
          title: 'Fuera de horario',
          text: 'No se permiten registros a partir de las 04:00 p.m. en la fecha actual.',
          confirmButtonText: 'Aceptar'
        });
        return;
      } else {



        const response = await axios.get(`/getEventos/${fecha}/${this.vehiculo.id_vehiculo}`);
        const eventos = response.data;

        const eventoExistente = eventos.find(ev =>
          ev.hora.substring(0, 5) === hora &&
          (ev.tipo_evento === "entrega_cita" || ev.tipo_evento === "recojo_cita")
        );

        if (eventoExistente) {
          await Swal.fire({
            icon: 'warning',
            title: 'Hora ocupada',
            html: `
        <p><strong>Tipo de evento:</strong> ${escaparHtml(eventoExistente.tipo_evento)}</p>
        <p><strong>Hora:</strong> ${escaparHtml(eventoExistente.hora.substring(0, 5))}</p>
        <p><strong>Observaciones:</strong> ${escaparHtml(eventoExistente.observaciones || 'Sin observaciones')}</p>
      `,
            confirmButtonText: 'Aceptar'
          });
          return;
        }

        this.datos.fecha_salida = fecha;
        this.datos.fecha_entrada = fecha;
        this.datos.horario_salida = hora;

        this.datos.id_vehiculo = this.vehiculo.id_vehiculo;
        this.datos.personal_chofer = this.vehiculo.id_chofer



        this.showModal = true
      }
    },

    closeModal() {
      this.showModal = false
      this.event = { title: '', time: '', id: null }
      this.datos = {
        horario_salida: '',
        fecha_entrada: '',
        personal_chofer: '',
        id_envio_local: null
      }
    },
    handleEventClick(info) {

      let title = info.event.title;

      if (title.includes("Tiempo reservado")) {
        return;
      }

      this.datos.personal_chofer = this.vehiculo.id_chofer
      this.datos.id_vehiculo = this.vehiculo.id_vehiculo;
      this.datos.id_envio_local = Number(info.event.id)
      this.showModal = true
    },

    viewDetails(vehiculo) {
      this.vehiculo = vehiculo
      this.showDetailModal = true
    },
    closeDetailModal() {
      this.showDetailModal = false
    },
    getBorderColor(colorEstado) {
      if (!colorEstado) return '#9e9e9e';
      const c = colorEstado.toLowerCase().replace(/\s/g, '');
      if (c.includes('d4edda')) return '#28a745';
      if (c.includes('fff3cd')) return '#ffc107';
      if (c.includes('f8d7da')) return '#dc3545';
      return '#9e9e9e';
    },
    toggleCalendario(index) {
      const vehiculo = this.vehiculos[index]
      vehiculo.mostrarCalendario = !vehiculo.mostrarCalendario;
      // Al reabrir, la agenda se crea de nuevo con la fecha de la cabecera
      if (!vehiculo.mostrarCalendario) {
        delete this.opcionesPorVehiculo[vehiculo.id_vehiculo]
        vehiculo.fechaAgenda = null
      }
    },



  }, mounted() {
    this.getVehiculos()
  }
}
</script>

<style scoped>
/* ── Wrapper ── */
.prog-wrapper { padding: 0; }

/* ── Page header actions ── */
.prog-header-actions {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}
/* Cabecera clara (estándar): controles con borde y texto oscuro */
.prog-date-input {
  height: 34px;
  border: 1.5px solid #e0e3f5;
  border-radius: 8px;
  padding: 0 10px;
  font-size: 0.82rem;
  background: #fff;
  color: #37474f;
  outline: none;
}
.prog-date-input:focus { border-color: #3f51b5; box-shadow: 0 0 0 3px rgba(63,81,181,0.12); }
.prog-btn {
  height: 34px;
  border: 1.5px solid transparent;
  border-radius: 8px;
  padding: 0 14px;
  font-size: 0.82rem;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  transition: background 0.15s, border-color 0.15s;
}
.prog-btn:disabled { opacity: 0.6; cursor: wait; }
.prog-btn-primary  { background: #3f51b5; color: #fff; }
.prog-btn-primary:hover:not(:disabled) { background: #303f9f; }
.prog-btn-secondary { background: #fff; color: #3f51b5; border-color: #c5cae9; }
.prog-btn-secondary:hover { background: #f4f5fb; border-color: #9fa8da; }

/* Vista del día: el iframe ocupa todo el alto disponible del modal (sin doble scroll) */
.prog-iframe-body { overflow: hidden; }
.prog-iframe { display: block; width: 100%; height: calc(100vh - 2rem - 62px); border: 0; }
.prog-iframe-cargando { padding: 40px; text-align: center; color: #8592a3; font-size: 0.85rem; }
.prog-vbtn:disabled { opacity: 0.6; cursor: wait; }

/* ── Leyenda ── */
.prog-leyenda {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  padding: 10px 4px 14px;
}
.leyenda-label {
  font-size: 0.78rem;
  font-weight: 700;
  color: #616161;
  text-transform: uppercase;
  letter-spacing: 0.4px;
}
.leyenda-chip {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 0.8rem;
  font-weight: 600;
  border: 1px solid;
}
.leyenda-dot { width: 10px; height: 10px; border-radius: 50%; flex-shrink: 0; }

/* ── Vehicle cards ── */
.prog-vehicles { display: flex; flex-direction: column; gap: 14px; }
.prog-vehicle-card {
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 2px 10px rgba(63,81,181,0.08);
  border-left: 5px solid #9e9e9e;
  overflow: hidden;
}
.prog-vehicle-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px 18px;
  gap: 12px;
  flex-wrap: wrap;
}
.prog-vehicle-info { flex: 1; min-width: 0; }
.prog-vehicle-name {
  font-size: 1rem;
  font-weight: 700;
  color: #212121;
  display: flex;
  align-items: center;
  margin-bottom: 4px;
}
.prog-vehicle-detail { font-size: 0.78rem; color: #546e7a; line-height: 1.5; }
.prog-vehicle-actions { display: flex; gap: 6px; flex-wrap: wrap; align-items: center; }
.prog-vbtn {
  background: rgba(63,81,181,0.1);
  color: #3f51b5;
  border: 1px solid rgba(63,81,181,0.25);
  border-radius: 6px;
  padding: 5px 11px;
  font-size: 0.78rem;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  transition: background 0.15s;
}
.prog-vbtn:hover { background: rgba(63,81,181,0.18); }
.prog-vbtn-pdf { background: rgba(198,40,40,0.08); color: #c62828; border-color: rgba(198,40,40,0.25); }
.prog-vbtn-pdf:hover { background: rgba(198,40,40,0.16); }
.prog-vbtn-warn { background: rgba(255,160,0,0.1); color: #e65100; border-color: rgba(255,160,0,0.3); }
.prog-vbtn-warn:hover { background: rgba(255,160,0,0.2); }

/* ── Calendar body ── */
.prog-calendar-body { border-top: 1px solid #e8eaf6; padding: 0; }

/* ── Detail table ── */
.prog-detail-table { width: 100%; border-collapse: collapse; font-size: 0.82rem; }
.prog-detail-table td { padding: 8px 14px; border-bottom: 1px solid #f0f0f0; vertical-align: middle; }
.prog-detail-table .det-label {
  font-weight: 700;
  color: #546e7a;
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  background: #f8f9fa;
}
.prog-detail-table .det-section-header {
  background: linear-gradient(90deg, #3f51b5 0%, #5c6bc0 100%);
  color: #fff;
  font-weight: 700;
  font-size: 0.78rem;
  text-transform: uppercase;
  padding: 7px 14px;
  letter-spacing: 0.5px;
}

/* ── Fade transition ── */
.fade-enter-active, .fade-leave-active { transition: opacity 0.25s; }
.fade-enter-from, .fade-leave-to { opacity: 0; }
</style>

<style>
/* ── FullCalendar toolbar ── */
.fc .fc-toolbar {
  background: linear-gradient(90deg, #3f51b5 0%, #5c6bc0 100%);
  padding: 10px 16px;
  border-radius: 0;
  margin-bottom: 0 !important;
}
.fc .fc-toolbar-title { font-size: 1rem !important; font-weight: 700; color: #fff !important; text-transform: capitalize; }
.fc .fc-button {
  background: rgba(255,255,255,0.18) !important;
  border: 1px solid rgba(255,255,255,0.35) !important;
  color: #fff !important;
  font-size: 0.8rem !important;
  padding: 4px 12px !important;
  border-radius: 6px !important;
  font-weight: 600;
  box-shadow: none !important;
  transition: background 0.15s;
}
.fc .fc-button:hover { background: rgba(255,255,255,0.32) !important; }
.fc .fc-button-active, .fc .fc-button:focus { background: rgba(255,255,255,0.35) !important; outline: none !important; box-shadow: none !important; }
.fc .fc-col-header { background: #e8eaf6; }
.fc .fc-col-header-cell-cushion { font-size: 0.92rem !important; font-weight: 700; color: #3f51b5 !important; text-decoration: none !important; padding: 8px 0; }
.fc .fc-timegrid-slot-label-cushion { font-size: 0.75rem; font-weight: 600; color: #757575; }
.fc .fc-timegrid-slot { background-color: #fff !important; height: 200px !important; border-color: #eeeeee !important; }
.fc .fc-timegrid-slot-minor { border-top-style: dashed !important; border-color: #f5f5f5 !important; }
.fc .fc-event { border: none !important; border-radius: 6px !important; box-shadow: 0 2px 6px rgba(0,0,0,0.10); cursor: pointer; }
.fc .fc-timegrid-event { height: 200px !important; width: 280px !important; border-radius: 6px !important; }
.fc .fc-timegrid-col-events .fc-timegrid-event-harness { display: flex; justify-content: flex-start; align-items: flex-start; }
.fc-event-inner { padding: 4px 6px; font-size: 11px; line-height: 1.5; color: #212121; overflow: hidden; }
.fc-event-line { white-space: normal; overflow-wrap: break-word; word-break: break-word; }
.fc-event-line:first-child { font-weight: 700; font-size: 12px; margin-bottom: 2px; }
.fc .fc-timegrid-now-indicator-line { border-color: #e53935 !important; border-width: 2px !important; }
.fc .fc-timegrid-now-indicator-arrow { border-top-color: #e53935 !important; border-bottom-color: #e53935 !important; }
.fc .fc-view { background-color: white !important; }
.fc .fc-scrollgrid { border-color: #e0e0e0 !important; }
.modal { z-index: 90; }
#iframeModal { z-index: 1090; }

.camiones {
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
}

.camion-card {
  padding: 10px;
  margin: 10px;

  background-color: #f9f9f9;
}

table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.75rem;
}



th {
  background-color: #cce5ff;
}

.btn-cerrar {
  border: transparent;
  background: transparent;
  float: right;
  font-size: 1.3rem;
}

.btn-custom {
  background-color: #e2e6ea;
  color: #212529;
}

.modal {
  z-index: 90 !important;
}

#iframeModal {
  z-index: 1090;
}
</style>
